export const domain = "https://us-east-2paf5weszy.auth.us-east-2.amazoncognito.com";
export const clientId = "5l78c8t1qcqdv9r07q7u74ud39";
export const redirectUri = "https://dashboard.wrkspot.com";